import { useEffect, useState } from "react";
import { attachmentBlobUrl } from "@/lib/attachments";
import { ImageSquare } from "@phosphor-icons/react";

/**
 * Thumb — lightweight thumbnail for a single attachment.
 * Uses shared blob cache. Falls back to elegant placeholder.
 * Optionally clickable to open a larger preview.
 */
export default function Thumb({ attachment, size = 56, onClick, testId, roundedNone = true, alt = "" }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let mounted = true;
    if (attachment?.is_image) {
      attachmentBlobUrl(attachment.id).then((u) => { if (mounted) setUrl(u); });
    } else {
      setUrl(null);
    }
    return () => { mounted = false; };
  }, [attachment?.id, attachment?.is_image]);

  const w = size, h = size;
  const cls = `inline-flex items-center justify-center overflow-hidden shrink-0 border`;
  const style = {
    width: w, height: h,
    background: "#F4F3ED",
    borderColor: "var(--nylsu-border)",
    borderRadius: roundedNone ? 0 : 4,
  };

  if (!attachment) {
    return (
      <div className={cls} style={style} data-testid={testId} aria-hidden>
        <ImageSquare size={Math.round(size * 0.4)} weight="light" className="text-[#B8B5A8]" />
      </div>
    );
  }

  if (attachment.is_image && url) {
    const Tag = onClick ? "button" : "span";
    const extra = onClick ? { type: "button", onClick, "aria-label": alt } : {};
    return (
      <Tag
        {...extra}
        data-testid={testId}
        className={cls}
        style={{ ...style, cursor: onClick ? "zoom-in" : "default" }}
      >
        <img src={url} alt={alt} loading="lazy" className="w-full h-full object-cover" />
      </Tag>
    );
  }

  // Non-image attachment (rare for a "primary") — placeholder
  return (
    <div className={cls} style={style} data-testid={testId}>
      <ImageSquare size={Math.round(size * 0.4)} weight="light" className="text-[#B8B5A8]" />
    </div>
  );
}
